module.exports = __webpack_public_path__ + "static/media/doctor-nars.d108b94e.png";